import { render, staticRenderFns } from "./EditSortNumberSingleDialog.vue?vue&type=template&id=3a8cd98f&scoped=true"
import script from "./EditSortNumberSingleDialog.vue?vue&type=script&lang=ts"
export * from "./EditSortNumberSingleDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditSortNumberSingleDialog.vue?vue&type=style&index=0&id=3a8cd98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cd98f",
  null
  
)

export default component.exports